import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Artical from './artical';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        hasCopyRight: PropTypes.bool,
        sourceReason: PropTypes.string,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { content, hasCopyRight, sourceReason } = this.props;

        return (
            <div className={styles.content_box}>
                <div className={styles.space34} />
                <div className={styles.content}>
                    <div className={styles.box}>
                        <Artical content={content} hasCopyRight={hasCopyRight} sourceReason={sourceReason} />
                    </div>
                </div>
                <div className={styles.space30} />
            </div>
        );
    }
}

export default errorBoundary(Content);
